import Config from "../../gatsby-config"

export function GetISODate(date) {
  let dt = new Date(date)
  const tz = dt.getTimezoneOffset()
  dt.setMinutes(dt.getMinutes() + tz)
  return dt.toISOString()
}

export default function courseGetCourse(param) {
  switch (param) {
    case 0:
      return "DMAE7110"
    case 1:
      return "DMAE7150"
    case 2:
      return "DMAE7175"
    case 3:
      return "DMAE7250"
    case 4:
      return "DMAE7270"
    case 5:
      return "DMAE7115"
    case 6:
      return "DMAE7155"
    case 7:
      return "DMAE7255"
    case 8:
      return "DMAE7120"
    case 9:
      return "ELECTIVE1"
    case 10:
      return "ELECTIVE2"
    case 11:
      return "ELECTIVE3"
    default:
      return "ERROR OUT OF RANGE"
  }
}

export function GetImageURL(image, youtube, vimeo) {
  let returnImage = {
    src: "",
    height: "0",
    width: "0",
  }
  if (image?.childImageSharp !== undefined) {
    returnImage.src = `${Config.siteMetadata.siteUrl}${image.childImageSharp.resize.src}`
    returnImage.width = image.childImageSharp.resize.width
    returnImage.height = image.childImageSharp.resize.height
  } else if (youtube?.thumbnails?.high?.url !== undefined) {
    returnImage.src = youtube?.thumbnails?.high?.url
    returnImage.width = youtube?.thumbnails?.high?.width
    returnImage.height = youtube?.thumbnails?.high?.height
  } else if (vimeo[0]?.thumbnail_url !== undefined) {
    if (vimeo[0].length !== 0) {
      returnImage.src = vimeo[0]?.thumbnail_url
      returnImage.width = vimeo[0]?.thumbnail_width
      returnImage.height = vimeo[0]?.thumbnail_height
    }
  }
  return returnImage
}

export function AppendImage(image){
  if (image !== undefined)
  {
    image.src = `${Config.siteMetadata.siteUrl}${image.src}`
    return image
  }
  return undefined
}
